const dir = location.pathname
	.split('/')
	.filter(Boolean)
	.pop();

export function loginCheck() {
	let url = document.querySelector('.modal-form-main--signin').getAttribute('action');
	let option = {
		method: 'POST',
		// credentials: 'same-origin',
		credentials: 'include'
	};

	if (
		location.host === 'chemrest.localhost' ||
		location.host === 'localhost' ||
		location.hash.indexOf('mode=develop') > -1
	) {
		url = '/_develop/auth.json';
	}

	if (dir === void 0) {
		url = '/us_region/en/login/login_check.html';
	}

	return new Promise((resolve, reject) => {
		fetch(url, option)
			.then(res => {
				return res.json();
			})
			.then(json => {
				resolve(json);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export function loginAuth(options) {
	let url = document
		.querySelector('.modal-form-main--signin')
		.getAttribute('action')
		.replace('login_check', 'auth');
	let option = {};
	let data = { id: options.id, pass: options.pass, keep: options.keep };
	let body = new FormData();

	body.append('json', JSON.stringify(data));

	option = {
		method: 'POST',
		// credentials: 'same-origin',
		credentials: 'include',
		body: body
	};

	if (
		location.host === 'chemrest.localhost' ||
		location.host === 'chemrest.localhost:3000' ||
		location.hash.indexOf('mode=develop') > -1
	) {
		url = '/_develop/auth.json';
	}

	if (dir === void 0) {
		url = '/us_region/en/login/auth.html';
	}

	return new Promise((resolve, reject) => {
		fetch(url, option)
			.then(res => {
				return res.json();
			})
			.then(json => {
				resolve(json);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export function loginForgot(email) {
	let url = document.querySelector('.modal-form-main--forgot').getAttribute('action');
	let option = {};
	let data = { id: email, ret: 'json' };
	let body = new FormData();

	body.append('json', JSON.stringify(data));

	option = {
		method: 'POST',
		// credentials: 'same-origin',
		credentials: 'include',
		body: body
	};

	if (
		location.host === 'chemrest.localhost' ||
		location.host === 'chemrest.localhost:3000' ||
		location.hash.indexOf('mode=develop') > -1
	) {
		url = '/_develop/forgot.json';
	}

	if (dir === void 0) {
		url = '/us_region/en/login/forget.html';
	}

	return new Promise((resolve, reject) => {
		fetch(url, option)
			.then(res => {
				return res.json();
			})
			.then(json => {
				resolve(json);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export function logout() {
	let url = document
		.querySelector('.modal-form-main--signin')
		.getAttribute('action')
		.replace('login_check', 'logout');
	let option = {
		method: 'POST',
		// credentials: 'same-origin',
		credentials: 'include'
	};

	if (dir === void 0) {
		url = '/us_region/en/login/logout.html';
	}

	return new Promise((resolve, reject) => {
		fetch(url, option)
			.then(res => {
				return res.json();
			})
			.then(json => {
				resolve(json);
			})
			.catch(err => {
				reject(err);
			});
	});
}



// WEBPACK FOOTER //
// ./src/js/module/login.js